/** Item do GET /reviews/recusadas/alerta. */
export type ItemRecusada = {
  reviewExternalId: string;
  perfil?: string | null;
  perfilPublicId?: string | null;
  autor?: string | null;
  estrelas?: string | null;
  comentario?: string | null;
  resposta?: string | null;
  estado?: string | null;
  motivo?: string | null;
  linkNoGoogle?: string | null;
  recusadaEm?: string | null;
};

/**
 * O motivo chega como o JSON cru de policyViolation do Google. Mostra o texto
 * legível quando houver; senão, diz só que foi recusada.
 */
export const textoDoMotivo = (item: Pick<ItemRecusada, "motivo" | "estado">): string => {
  const cru = item.motivo?.trim();
  if (cru) {
    try {
      const json = JSON.parse(cru);
      const texto =
        (typeof json === "string" && json) ||
        json?.description ||
        json?.message ||
        json?.policy ||
        json?.reason ||
        json?.type;
      if (texto) return `Motivo do Google: ${String(texto)}`;
    } catch {
      return `Motivo do Google: ${cru}`;
    }
  }
  return item.estado?.toUpperCase() === "REJECTED"
    ? "Recusada pelo Google (sem motivo informado)."
    : "Recusada pelo Google.";
};
